import axios from '../config/axiosConfig';

const API_URL = '/web-targets';

const getAll = async (projectId) => {
  const response = await axios.get(API_URL, { params: { projectId } });
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

const create = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

const update = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

const remove = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

const addSiteMapEntry = async (id, entry) => {
  const response = await axios.post(`${API_URL}/${id}/site-map`, entry);
  return response.data;
};

const importData = async (id, format, content) => {
  const response = await axios.post(`${API_URL}/${id}/import`, { format, content });
  return response.data;
};

// Replace the project's manual URL list (and optionally the excluded-URL list)
const saveManualUrls = async (id, urls, excludedUrls) => {
  const body = { urls };
  if (Array.isArray(excludedUrls)) body.excludedUrls = excludedUrls;
  const response = await axios.put(`${API_URL}/${id}/manual-urls`, body);
  return response.data;
};

// Proxy CA (fixed per target; only rotates on explicit regenerate)
const getProxyCa = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/proxy-ca`, { responseType: 'text' });
  return response.data;
};
const getProxyCaInfo = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/proxy-ca/info`);
  return response.data;
};
const regenerateProxyCa = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/regenerate-proxy-ca`);
  return response.data;
};

// Variables & OAuth2
const getVariables = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/variables`);
  return response.data;
};
const setVariable = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}/variables`, data);
  return response.data;
};
const deleteVariable = async (id, key) => {
  const response = await axios.delete(`${API_URL}/${id}/variables/${encodeURIComponent(key)}`);
  return response.data;
};
const saveOAuth2Config = async (id, config) => {
  const response = await axios.put(`${API_URL}/${id}/oauth2-config`, config);
  return response.data;
};
const fetchToken = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/fetch-token`);
  return response.data;
};

const webTargetService = {
  getAll,
  getById,
  create,
  update,
  remove,
  addSiteMapEntry,
  importData,
  saveManualUrls,
  getProxyCa,
  getProxyCaInfo,
  regenerateProxyCa,
  getVariables,
  setVariable,
  deleteVariable,
  saveOAuth2Config,
  fetchToken
};

export default webTargetService;
